module.exports = __webpack_public_path__ + "static/media/image-1.1f2652c4.jpg";